<template>
  <section id="partnership" class="partnership">
    <div class="container">
      <div class="partnership__header">
        <span class="section-label">PARTNERSHIP</span>
        <h2 class="section-title">商务合作</h2>
        <p class="section-desc">期待与您建立深度合作，共同拓展数字绘画生态</p>
      </div>
      <div class="partnership__cards">
        <div class="partner-card" v-for="(item, index) in partnerships" :key="index">
          <div class="partner-card__icon-wrap">
            <img :src="item.icon" :alt="item.title" class="partner-card__icon" />
          </div>
          <h3 class="partner-card__title">{{ item.title }}</h3>
          <p class="partner-card__desc">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import usersIcon from '@/assets/icons/users.svg'
import codeIcon from '@/assets/icons/code.svg'
import linkIcon from '@/assets/icons/link.svg'

export default {
  name: 'PartnershipSection',
  data() {
    return {
      partnerships: [
        { title: '品牌合作', description: '联合推广、品牌联名、活动合作', icon: usersIcon },
        { title: '技术合作', description: 'SDK授权、引擎集成、定制开发', icon: codeIcon },
        { title: '渠道合作', description: '应用商店、硬件厂商、教育渠道', icon: linkIcon }
      ]
    }
  }
}
</script>

<style scoped>
.partnership {
  padding: 100px 0;
}

.partnership__header {
  text-align: center;
  margin-bottom: 48px;
}

.partnership__cards {
  display: flex;
  margin-left: -10px;
  margin-right: -10px;
}

.partner-card {
  flex: 1;
  background-color: #141419;
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
}

.partner-card__icon-wrap {
  width: 40px;
  height: 40px;
  background-color: #1E1E2A;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.partner-card__icon {
  width: 20px;
  height: 20px;
}

.partner-card__title {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.partner-card__desc {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #9CA3AF;
}

@media (max-width: 1024px) {
  .partnership {
    padding: 80px 0;
  }
  .partnership__header {
    margin-bottom: 40px;
  }
  .partner-card {
    padding: 20px;
    margin: 0 8px;
  }
  .partnership__cards {
    margin-left: -8px;
    margin-right: -8px;
  }
  .partner-card__title {
    font-size: 16px;
  }
  .partner-card__desc {
    font-size: 14px;
    line-height: 20px;
  }
}

@media (max-width: 768px) {
  .partnership {
    padding: 60px 0;
  }
  .partnership__header {
    margin-bottom: 32px;
  }
  .partnership__cards {
    flex-direction: column;
    margin: 0;
    gap: 16px;
  }
  .partner-card {
    margin: 0;
    padding: 20px;
  }
  .partner-card__title {
    font-size: 16px;
  }
  .partner-card__desc {
    font-size: 13px;
    line-height: 18px;
  }
}

@media (max-width: 480px) {
  .partnership {
    padding: 48px 0;
  }
  .partner-card {
    padding: 16px;
  }
}
</style>
